import React from 'react';
import moment, { MomentZoneOffset } from 'moment-timezone';
import { Typography } from '@material-ui/core';
import { timezoneNames, USTimezones } from 'common/constants/timezones';

export const renderTimezoneOption = (timezone: string) => {
  const offset = moment.tz(timezone).format('Z');
  const timezoneLabel = timezoneNames[offset] || `GMT ${offset}`;

  return (
    <>
      <Typography component="span" variant="inherit">
        {`${moment.tz(timezone).format('h:mm A')} (${timezoneLabel})`}
      </Typography>
    </>
  );
};

export const getTimezones = (): MomentZoneOffset[] => {
  const uniqueOffsets = new Set<string>();

  const filteredTimezones = USTimezones.filter(({ name: timezoneName }) => {
    const offset = moment.tz(timezoneName).format('Z');
    if (!uniqueOffsets.has(offset)) {
      uniqueOffsets.add(offset);
      return true;
    }
    return false;
  });

  return filteredTimezones;
};
